import uniqueId from 'lodash.uniqueid';

import styles from './backlight-text.module.css';

interface Props {
  searchQuery: string;
  text: string;
  className?: string;
}

export default function Highlight({
  searchQuery,
  text,
  className = '',
}: Props): React.JSX.Element {
  const displayHighlightedPart = (search: string, txt: string) => {
    // Split on highlight term and include term into parts, ignore case
    const originaltxt = txt.split(
      new RegExp(`(${search.replace(/[^a-zA-Z0-9]/g, '')})`, 'gi'),
    );
    const parts = txt
      .toLowerCase()
      .split(
        new RegExp(
          `(${search.replace(/[^a-zA-Z0-9]/g, '').toLowerCase()})`,
          'gi',
        ),
      );

    return (
      <>
        {parts.map((part, i) => (
          <span
            key={uniqueId('-')}
            className={
              part.includes(search.toLowerCase()) && search.length
                ? `${styles.highlighted} ${className}`
                : ''
            }
          >
            {originaltxt[i]}
            {i === parts.length - 1 && ' '}
          </span>
        ))}
      </>
    );
  };

  return displayHighlightedPart(searchQuery, text);
}
